/** Textes repris sur les pièces — éditeur enrichi. */
import { RichText } from "../../components/RichText";
import { useCompany } from "../../company/CompanyProvider";
import type { CompanyDraft } from "./types";

type CompanyDefaultsProps = {
  draft: CompanyDraft;
  setDraft: (next: CompanyDraft) => void;
};

const FIELDS: { key: keyof CompanyDraft; label: string }[] = [
  { key: "invoice_terms", label: "Conditions de facturation" },
  { key: "invoice_footer", label: "Pied de facture" },
  { key: "quote_terms", label: "Conditions des devis" },
  { key: "quote_footer", label: "Pied de page des devis" },
  { key: "credit_terms", label: "Conditions d’utilisation pour avoir" },
  { key: "credit_footer", label: "Pied de page avoir" },
];

export function CompanyDefaults({ draft, setDraft }: CompanyDefaultsProps) {
  const { company } = useCompany();
  const resetKey = company?.id ?? 0;

  return (
    <div className="fx-co-texts">
      <p className="fx-co-form__hint">
        Texte libre en plus — les mentions légales (293 B, pénalités, 40 €, identité) sont écrites par le logiciel.
      </p>
      {FIELDS.map((f) => (
        <RichText
          key={`${resetKey}-${f.key}`}
          label={f.label}
          value={String(draft[f.key] ?? "")}
          resetKey={`${resetKey}-${f.key}`}
          onChange={(html) => setDraft({ ...draft, [f.key]: html })}
        />
      ))}
    </div>
  );
}
